import React from 'react';
import { ErrorPage } from '../../components';

const NotFound = () => {
  return <ErrorPage text="Not Found" />;
};

export default NotFound;
